import { createPortal } from 'react-dom';
import PupCard from './PupCard';
import './PupCardPreview.css';

// Transient full-card preview shown while a Pup name in the log is press-and-held (LogLine.js).
// Deliberately NOT PupCardDetail: this is a passive hover surface, not a modal — no backdrop-close,
// no X, no Esc, no dialog role. Portaled to <body> so it escapes the table's overflow:hidden, and
// the overlay is pointer-events:none so it can never intercept the pointer stream (the held button
// keeps pointer capture, so pointerup/pointercancel always return there to dismiss this). Reuses the
// full-size <PupCard> renderer (which self-heals an unknown code); `roomId` rides through so
// table-type-dependent text (the tournament removal note) renders correctly.
const PupCardPreview = ({ code, roomId }) =>
  createPortal(
    <div className="pup-card-preview-overlay">
      <PupCard code={code} roomId={roomId} />
    </div>,
    document.body,
  );

export default PupCardPreview;
